import React from 'react';
import './FourColumn.scss';
import { FourColumnColumn } from './FourColumnColumn';

export const FourColumn = ({ node }) => {
    if (
        !node.relationships?.field_four_column_columns ||
        node.relationships?.field_four_column_columns?.length < 4
    ) {
        return (
            <p className="kite-container component-error">
                ERROR: Four column -- all four columns must be populated.
            </p>
        );
    }

    return (
        <section
            className={`themed-container c--four-column ${node.field_theme?.toLowerCase()} ${node.field_appearance_fwcd?.toLowerCase()}`}
        >
            <div
                className={`kite-container  ${node.field_lc_align?.toLowerCase()}  ${node.field_appearance_fwcd?.toLowerCase()}`}
            >
                {node.relationships?.field_four_column_columns?.map(
                    (col, idx) => {
                        col.bg = node.field_theme?.toLowerCase();
                        return <FourColumnColumn key={idx} node={col} />;
                    }
                )}
            </div>
        </section>
    );
};
